/**
 * Formattazione monetaria condivisa (convenzione italiana): "1.234,56 €".
 *
 * Gli importi sono SEMPRE in centesimi interi (come nel backend). Non usare per
 * i calcoli: solo per la visualizzazione. Il totale autorevole arriva dal backend.
 */
// In it-IT il separatore delle migliaia parte dalle decine di migliaia
// (minimumGroupingDigits 2): «1218,60 €» invece di «1.218,60 €». "always" è
// ES2023; i tipi di TypeScript in uso non lo conoscono ancora, e un browser più
// vecchio lo legge come `true`, cioè il comportamento di prima.
const EURO = { style: "currency", currency: "EUR", useGrouping: "always" } as unknown as Intl.NumberFormatOptions;

export function formatEuro(cents: number | null | undefined): string {
  return new Intl.NumberFormat("it-IT", EURO).format((cents ?? 0) / 100);
}
